import React from "react";
import { Text, TextInput, useTranslation } from "@familyzone/component-library";
import { FilteringSourceCriteria } from "../criteriaTypes";

export interface HTTPPathCriteriaProps {
  criteria: FilteringSourceCriteria;
  disabled: boolean;
  onChange: (criteria: FilteringSourceCriteria) => void;
}

const HTTPPathCriteria: React.FC<HTTPPathCriteriaProps> = ({ criteria, disabled, onChange }) => {
  const { t } = useTranslation();

  if (Array.isArray(criteria.conditions)) {
    return <Text>{t("Invalid Criteria")}</Text>;
  }

  const handleChangeRequestPath = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange({ ...criteria, conditions: { expression: e.target.value } });
  };

  return (
    <TextInput
      name="request path"
      placeholder={t("Request Path")}
      isDisabled={disabled}
      value={String(criteria.conditions.expression)}
      onChange={handleChangeRequestPath}
    />
  );
};

export default HTTPPathCriteria;
